module.exports = __webpack_public_path__ + "img/error.9c5d12a4.png";